/* @ts-nocheck */
import {
  AngleLeft,
  AngleRight,
} from '@alefeducation/ui-elements-library-icons';
import React, { useEffect, useRef, useState } from 'react';
import { CalendarProps as ReactCalendarProps } from 'react-calendar';
import { createPortal } from 'react-dom';
import { StyledCalendar } from './DatePicker.styled';

const POSITION_X_OFFSET = -220;
const POSITION_Y_OFFSET = 10;

export type CalendarProps = {
  value: Date;
  isOpen: boolean;
  onChange: (value: Date) => void;
  onClose: () => void;
  minDate?: Date;
  maxDate?: Date;
  customCalendarProps?: Partial<ReactCalendarProps>;
  children: React.ReactNode;
};

export const DatePicker = ({
  isOpen,
  value,
  onChange,
  onClose,
  minDate,
  children,
  customCalendarProps,
}: CalendarProps) => {
  const [cords, setCords] = useState<{ x: number; y: number }>();
  const calendarRef = useRef<HTMLDivElement>(null);
  const childrenRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    // @ts-ignore
    function handleClickOutside(event) {
      if (calendarRef.current && !calendarRef.current!.contains(event.target)) {
        onClose();
      }
    }

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [calendarRef]);

  useEffect(() => {
    const onResize = () => {
      if (childrenRef && childrenRef.current) {
        const { left, top } = childrenRef.current.getBoundingClientRect();
        const width = childrenRef.current.offsetWidth;
        const height = childrenRef.current.offsetHeight;
        setCords({
          x: left + width / 2 + POSITION_X_OFFSET,
          y: top + height + POSITION_Y_OFFSET,
        });
      }
    };
    window.addEventListener('resize', onResize);
    onResize();
    return () => window.removeEventListener('resize', onResize);
  }, [childrenRef.current, isOpen]);

  return (
    <>
      <div ref={childrenRef}>{children}</div>
      {isOpen &&
        createPortal(
          <div ref={calendarRef}>
            <StyledCalendar
              x={cords?.x || 0}
              y={cords?.y || 0}
              minDetail="month"
              minDate={minDate}
              formatShortWeekday={(locale, date) => date.toDateString()[0]}
              onClickDay={onClose}
              prevLabel={<AngleLeft color="#485465" height={12} width={12} />}
              prev2Label={null}
              nextLabel={<AngleRight color="#485465" height={12} width={12} />}
              next2Label={null}
              onChange={(s, e) => {
                const selected = new Date(s as Date);
                selected.setHours(23, 59, 59);
                onChange(selected);
              }}
              defaultValue={minDate}
              value={value}
              {...customCalendarProps}
            />
          </div>,
          document.body,
        )}
    </>
  );
};
